export enum RoleTypes {
  PrimaryUser = 'primary-user',
  AdminUser = 'system-administrator-user-account',
  WorkshopAdmin = 'workshop-admin'
}
